import { create } from "zustand";
import { persist } from "zustand/middleware";

// please check src/action/auth-action.ts
interface User {
    username: string;
    email?: string;
    phone_number: string;
    is_business_owner: boolean;
    business_id?: string;
    business_domain?: string;
    business_name?: string;
    is_manager?: boolean;
    business_logo?: string;
    business_category?: string;
}

type UserDataState = {
    userData: User;
    setUserData: (data: User) => void;
    deleteUserData: () => void;
}

const initialUserData: User = {
    username: "",
    email: "",
    phone_number: "",
    is_business_owner: false,
    business_id: "",
    business_domain: "",
    business_name: "",
    is_manager: false,
    business_logo: "",
};

export const useUserData = create<UserDataState>()(
    persist(
        (set) => ({
            userData: initialUserData,
            setUserData: (data: User) => set({ userData: data }),
            deleteUserData: () => set({ userData: initialUserData }),
        }),
        {
            name: "user-data",
        }
    )
)